import { ConnectButton as RainbowKitConnectButton } from "@rainbow-me/rainbowkit";

export default function ConnectButton() {
  return <RainbowKitConnectButton />;
}